import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { getBreakpointFromManor } from 'ctm-components';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    content: {
        color: theme.colors.grey800,
        fontWeight: theme.fontWeight.normal,
        fontSize: theme.fontSize.base,
        lineHeight: '2rem'
    }
}));

const ErrorContent = (props) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme, breakpoint });
    const { className } = props;

    return (
        <div className={className}>
            <Typography className={classNames(classes.content)}>
                {'Sorry, it seems like you might have experienced a technical error.'}
            </Typography>
            <br />
            <Typography className={classNames(classes.content)}>
                {'Please try again by starting a new quote'}
            </Typography>
        </div>
    );
};

ErrorContent.propTypes = {
    className: PropTypes.string
};

export { ErrorContent };
